import { render, staticRenderFns } from "./ProjectConfigApprovals.vue?vue&type=template&id=60ba0366&scoped=true"
import script from "./ProjectConfigApprovals.vue?vue&type=script&lang=js"
export * from "./ProjectConfigApprovals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ba0366",
  null
  
)

export default component.exports